import { combineReducers } from 'redux';
import { addTeamPermissionReducer } from './add-team-permission.reducer';
import { deleteTeamPermissionReducer } from './delete-team-permission.reducer';

export const permissionsReducer = combineReducers({
    add: addTeamPermissionReducer,
    delete: deleteTeamPermissionReducer
});
